import { displayFlexCentered } from "../../styles/commons"
import { css } from "@emotion/react"
import { GlobalToken } from "antd"

export const globalErrorContainer: any = css`
  ${displayFlexCentered};
  background: white;
  flex-direction: column;
  height: 100%;

  .error-rangoon {
    max-width: 100%;
  }
  .error-text {
    text-align: center;
    font-size: 8px;
  }

  @media screen and (min-width: 992px) {
    .error-rangoon {
      max-width: 80vw;
    }
    .error-text {
      font-size: unset;
    },
  },
`

export const localErrorContainer: any = (theme: GlobalToken) => css`
	${displayFlexCentered};
	background: white;
	flex-direction: column;
	height: 100%;
	padding: 1em;

	.error-rangoon {
		max-width: 100%;
	}

	.error-text {
		text-align: center;
		font-size: 3px;
	}

	@media screen and (min-width: 992px) {
		.error-rangoon {
			height: 80vh;
		}
		.error-text {
			font-size: 5px;
		}
	}
`

export const notFoundErrorContainer: any = (theme: GlobalToken) => css`
	color: ${theme.colorPrimary};
	${displayFlexCentered};
	height: 100vh;
	.error-image {
		height: 60%;
	}
`

export const resultCss = (theme: GlobalToken) => css`
	color: ${theme.colorText};
	background: ${theme.colorBgContainer};
	height: 100%;

	.ant-result {
		height: 100%;
	}

	.ant-result-content {
		text-align: center;
	}
`
